module.exports = __webpack_public_path__ + "img/Button_Stop.e448f4f4.png";